import { differenceInMilliseconds } from "date-fns";

export const ANNOTATION_MESSAGE_ACTION_WINDOW_MS = 2 * 60 * 60 * 1000;

export const canManageAnnotationMessage = ({ annotation, currentOwnerUid }) => {
  if (!annotation?.userID || annotation.userID !== currentOwnerUid)
    return false;
  if (annotation.isOptimistic) return false;

  const creationTime = Number(annotation.creationTime);
  if (!creationTime || Number.isNaN(creationTime)) return false;

  return (
    differenceInMilliseconds(new Date(), new Date(creationTime)) <=
    ANNOTATION_MESSAGE_ACTION_WINDOW_MS
  );
};
